import type { WordPackDefinition } from "./types";

// Space pack - astronomy, exploration, cosmic phenomena
export const SPACE_WORDS = [
  // Solar System
  "SUN", "MERCURY", "VENUS", "EARTH", "MARS", "JUPITER", "SATURN", "URANUS", "NEPTUNE", "PLUTO",
  "MOON", "ASTEROID", "COMET", "METEOR", "CRATER", "RING", "ORBIT", "ECLIPSE", "EQUINOX", "SOLSTICE",
  "TITAN", "EUROPA", "GANYMEDE", "CALLISTO", "IO", "TRITON", "PHOBOS", "DEIMOS", "CHARON", "CERES",
  // Stars & Galaxies
  "STAR", "CONSTELLATION", "GALAXY", "NEBULA", "SUPERNOVA", "PULSAR", "QUASAR", "BLACK HOLE", "WHITE DWARF", "RED GIANT",
  "MILKY WAY", "ANDROMEDA", "ORION", "CASSIOPEIA", "URSA", "POLARIS", "SIRIUS", "BETELGEUSE", "VEGA", "RIGEL",
  "BINARY", "CLUSTER", "SPIRAL", "ELLIPTICAL", "DWARF GALAXY", "DARK MATTER", "DARK ENERGY", "COSMIC RAY", "GAMMA RAY", "NOVA",
  // Space Exploration
  "ROCKET", "SHUTTLE", "CAPSULE", "MODULE", "STATION", "SATELLITE", "PROBE", "ROVER", "LANDER", "ORBITER",
  "ASTRONAUT", "COSMONAUT", "MISSION", "LAUNCH", "LIFTOFF", "COUNTDOWN", "TRAJECTORY", "DOCKING", "SPLASHDOWN", "REENTRY",
  "NASA", "APOLLO", "VOYAGER", "HUBBLE", "CURIOSITY", "PERSEVERANCE", "SPUTNIK", "SKYLAB", "COLUMBIA", "CHALLENGER",
  // Cosmic Phenomena
  "GRAVITY", "WORMHOLE", "SINGULARITY", "EVENT HORIZON", "SPACETIME", "DIMENSION", "ANTIMATTER", "PLASMA", "RADIATION", "VOID",
  "BIG BANG", "EXPANSION", "REDSHIFT", "BLUESHIFT", "DOPPLER", "PARALLAX", "LUMINOSITY", "MAGNITUDE", "LIGHT YEAR", "PARSEC",
  // Equipment & Technology
  "TELESCOPE", "OBSERVATORY", "ANTENNA", "RADAR", "SPECTROGRAPH", "PHOTOMETER", "GYROSCOPE", "THRUSTER", "SOLAR PANEL", "HEAT SHIELD",
  "SPACESUIT", "HELMET", "VISOR", "AIRLOCK", "HATCH", "PAYLOAD", "BOOSTER", "FUEL", "PROPELLANT", "OXIDIZER",
  // Concepts
  "COSMOS", "UNIVERSE", "INFINITY", "ETERNITY", "CELESTIAL", "EXTRATERRESTRIAL", "ALIEN", "UFO", "CONTACT", "SIGNAL",
  "COLONIZATION", "TERRAFORMING", "HABITAT", "BIOSPHERE", "ATMOSPHERE", "MAGNETOSPHERE", "EXOPLANET", "HABITABLE ZONE", "GOLDILOCKS", "FRONTIER",
  // Famous Astronomers & Missions
  "GALILEO", "COPERNICUS", "KEPLER", "NEWTON", "EINSTEIN", "HAWKING", "SAGAN", "ARMSTRONG", "ALDRIN", "GAGARIN",
];

export const SPACE_SEMANTIC_FAMILIES: string[][] = [
  ["SUN", "MERCURY", "VENUS", "EARTH", "MARS", "JUPITER", "SATURN", "URANUS", "NEPTUNE", "PLUTO"],
  ["MOON", "ASTEROID", "COMET", "METEOR", "CRATER", "RING", "ORBIT", "ECLIPSE"],
  ["STAR", "CONSTELLATION", "GALAXY", "NEBULA", "SUPERNOVA", "PULSAR", "QUASAR", "BLACK HOLE", "WHITE DWARF", "RED GIANT"],
  ["MILKY WAY", "ANDROMEDA", "ORION", "CASSIOPEIA", "URSA", "POLARIS", "SIRIUS", "BETELGEUSE", "VEGA", "RIGEL"],
  ["ROCKET", "SHUTTLE", "CAPSULE", "MODULE", "SATELLITE", "PROBE", "ROVER", "LANDER", "ORBITER", "MISSION", "LAUNCH", "LIFTOFF"],
  ["ASTRONAUT", "COSMONAUT", "NASA", "APOLLO", "VOYAGER", "HUBBLE", "SPUTNIK", "SKYLAB", "COLUMBIA", "CHALLENGER"],
  ["GRAVITY", "WORMHOLE", "SINGULARITY", "EVENT HORIZON", "SPACETIME", "DIMENSION", "ANTIMATTER", "RADIATION", "VOID"],
  ["TELESCOPE", "OBSERVATORY", "ANTENNA", "RADAR", "SPECTROGRAPH", "PHOTOMETER", "GYROSCOPE", "THRUSTER", "SOLAR PANEL", "HEAT SHIELD"],
  ["COSMOS", "UNIVERSE", "INFINITY", "CELESTIAL", "EXTRATERRESTRIAL", "ALIEN", "UFO", "CONTACT", "SIGNAL", "FRONTIER"],
];

export const SPACE_PACK: WordPackDefinition = {
  key: "space",
  words: SPACE_WORDS,
  semanticFamilies: SPACE_SEMANTIC_FAMILIES,
};
